(() => {
  // app/scripts/common/function/currencies.js
  var multiCurrency = {};
  multiCurrency.moneyFormats = {
    USD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} USD"
    },
    EUR: {
      money_format: "&euro;{{amount}}",
      money_with_currency_format: "&euro;{{amount}} EUR"
    },
    GBP: {
      money_format: "&pound;{{amount}}",
      money_with_currency_format: "&pound;{{amount}} GBP"
    },
    CAD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} CAD"
    },
    ALL: {
      money_format: "Lek {{amount}}",
      money_with_currency_format: "Lek {{amount}} ALL"
    },
    DZD: {
      money_format: "DA {{amount}}",
      money_with_currency_format: "DA {{amount}} DZD"
    },
    AOA: {
      money_format: "Kz{{amount}}",
      money_with_currency_format: "Kz{{amount}} AOA"
    },
    ARS: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} ARS"
    },
    AMD: {
      money_format: "{{amount}} AMD",
      money_with_currency_format: "{{amount}} AMD"
    },
    AWG: {
      money_format: "Afl{{amount}}",
      money_with_currency_format: "Afl{{amount}} AWG"
    },
    AUD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} AUD"
    },
    BBD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} Bds"
    },
    AZN: {
      money_format: "m.{{amount}}",
      money_with_currency_format: "m.{{amount}} AZN"
    },
    BDT: {
      money_format: "Tk {{amount}}",
      money_with_currency_format: "Tk {{amount}} BDT"
    },
    BSD: {
      money_format: "BS${{amount}}",
      money_with_currency_format: "BS${{amount}} BSD"
    },
    BHD: {
      money_format: "{{amount}}0 BD",
      money_with_currency_format: "{{amount}}0 BHD"
    },
    BYR: {
      money_format: "Br {{amount}}",
      money_with_currency_format: "Br {{amount}} BYR"
    },
    BZD: {
      money_format: "BZ${{amount}}",
      money_with_currency_format: "BZ${{amount}} BZD"
    },
    BTN: {
      money_format: "Nu {{amount}}",
      money_with_currency_format: "Nu {{amount}} BTN"
    },
    BAM: {
      money_format: "KM {{amount_with_comma_separator}}",
      money_with_currency_format: "KM {{amount_with_comma_separator}} BAM"
    },
    BRL: {
      money_format: "R$ {{amount_with_comma_separator}}",
      money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL"
    },
    BOB: {
      money_format: "Bs{{amount_with_comma_separator}}",
      money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB"
    },
    BWP: {
      money_format: "P{{amount}}",
      money_with_currency_format: "P{{amount}} BWP"
    },
    BND: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} BND"
    },
    BGN: {
      money_format: "{{amount}} \u043B\u0432",
      money_with_currency_format: "{{amount}} \u043B\u0432 BGN"
    },
    MMK: {
      money_format: "K{{amount}}",
      money_with_currency_format: "K{{amount}} MMK"
    },
    KHR: {
      money_format: "KHR{{amount}}",
      money_with_currency_format: "KHR{{amount}}"
    },
    KYD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} KYD"
    },
    XAF: {
      money_format: "FCFA{{amount}}",
      money_with_currency_format: "FCFA{{amount}} XAF"
    },
    CLP: {
      money_format: "${{amount_no_decimals}}",
      money_with_currency_format: "${{amount_no_decimals}} CLP"
    },
    CNY: {
      money_format: "&#165;{{amount}}",
      money_with_currency_format: "&#165;{{amount}} CNY"
    },
    COP: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} COP"
    },
    CRC: {
      money_format: "&#8353; {{amount_with_comma_separator}}",
      money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC"
    },
    HRK: {
      money_format: "{{amount_with_comma_separator}} kn",
      money_with_currency_format: "{{amount_with_comma_separator}} kn HRK"
    },
    CZK: {
      money_format: "{{amount_with_comma_separator}} K&#269;",
      money_with_currency_format: "{{amount_with_comma_separator}} K&#269;"
    },
    DKK: {
      money_format: "{{amount_with_comma_separator}}",
      money_with_currency_format: "kr.{{amount_with_comma_separator}}"
    },
    DOP: {
      money_format: "RD$ {{amount}}",
      money_with_currency_format: "RD$ {{amount}}"
    },
    XCD: {
      money_format: "${{amount}}",
      money_with_currency_format: "EC${{amount}}"
    },
    EGP: {
      money_format: "LE {{amount}}",
      money_with_currency_format: "LE {{amount}} EGP"
    },
    ETB: {
      money_format: "Br{{amount}}",
      money_with_currency_format: "Br{{amount}} ETB"
    },
    XPF: {
      money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
      money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} XPF"
    },
    FJD: {
      money_format: "${{amount}}",
      money_with_currency_format: "FJ${{amount}}"
    },
    GMD: {
      money_format: "D {{amount}}",
      money_with_currency_format: "D {{amount}} GMD"
    },
    GHS: {
      money_format: "GH&#8373;{{amount}}",
      money_with_currency_format: "GH&#8373;{{amount}}"
    },
    GTQ: {
      money_format: "Q{{amount}}",
      money_with_currency_format: "{{amount}} GTQ"
    },
    GYD: {
      money_format: "G${{amount}}",
      money_with_currency_format: "${{amount}} GYD"
    },
    GEL: {
      money_format: "{{amount}} GEL",
      money_with_currency_format: "{{amount}} GEL"
    },
    HNL: {
      money_format: "L {{amount}}",
      money_with_currency_format: "L {{amount}} HNL"
    },
    HKD: {
      money_format: "${{amount}}",
      money_with_currency_format: "HK${{amount}}"
    },
    HUF: {
      money_format: "{{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} Ft"
    },
    ISK: {
      money_format: "{{amount_no_decimals}} kr",
      money_with_currency_format: "{{amount_no_decimals}} kr ISK"
    },
    INR: {
      money_format: "Rs. {{amount}}",
      money_with_currency_format: "Rs. {{amount}}"
    },
    IDR: {
      money_format: "{{amount_with_comma_separator}}",
      money_with_currency_format: "Rp {{amount_with_comma_separator}}"
    },
    ILS: {
      money_format: "{{amount}} NIS",
      money_with_currency_format: "{{amount}} NIS"
    },
    JMD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} JMD"
    },
    JPY: {
      money_format: "&#165;{{amount_no_decimals}}",
      money_with_currency_format: "&#165;{{amount_no_decimals}} JPY"
    },
    JEP: {
      money_format: "&pound;{{amount}}",
      money_with_currency_format: "&pound;{{amount}} JEP"
    },
    JOD: {
      money_format: "{{amount}}0 JD",
      money_with_currency_format: "{{amount}}0 JOD"
    },
    KZT: {
      money_format: "{{amount}} KZT",
      money_with_currency_format: "{{amount}} KZT"
    },
    KES: {
      money_format: "KSh{{amount}}",
      money_with_currency_format: "KSh{{amount}}"
    },
    KWD: {
      money_format: "{{amount}}0 KD",
      money_with_currency_format: "{{amount}}0 KWD"
    },
    KGS: {
      money_format: "\u043B\u0432{{amount}}",
      money_with_currency_format: "\u043B\u0432{{amount}}"
    },
    LVL: {
      money_format: "Ls {{amount}}",
      money_with_currency_format: "Ls {{amount}} LVL"
    },
    LBP: {
      money_format: "L&pound;{{amount}}",
      money_with_currency_format: "L&pound;{{amount}} LBP"
    },
    LTL: {
      money_format: "{{amount}} Lt",
      money_with_currency_format: "{{amount}} Lt"
    },
    MGA: {
      money_format: "Ar {{amount}}",
      money_with_currency_format: "Ar {{amount}} MGA"
    },
    MKD: {
      money_format: "\u0434\u0435\u043D {{amount}}",
      money_with_currency_format: "\u0434\u0435\u043D {{amount}} MKD"
    },
    MOP: {
      money_format: "MOP${{amount}}",
      money_with_currency_format: "MOP${{amount}}"
    },
    MVR: {
      money_format: "Rf{{amount}}",
      money_with_currency_format: "Rf{{amount}} MRf"
    },
    MXN: {
      money_format: "$ {{amount}}",
      money_with_currency_format: "$ {{amount}} MXN"
    },
    MYR: {
      money_format: "RM{{amount}} MYR",
      money_with_currency_format: "RM{{amount}} MYR"
    },
    MUR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} MUR"
    },
    MDL: {
      money_format: "{{amount}} MDL",
      money_with_currency_format: "{{amount}} MDL"
    },
    MAD: {
      money_format: "{{amount}} dh",
      money_with_currency_format: "Dh {{amount}} MAD"
    },
    MNT: {
      money_format: "{{amount_no_decimals}} &#8366",
      money_with_currency_format: "{{amount_no_decimals}} MNT"
    },
    MZN: {
      money_format: "{{amount}} Mt",
      money_with_currency_format: "Mt {{amount}} MZN"
    },
    NAD: {
      money_format: "N${{amount}}",
      money_with_currency_format: "N${{amount}} NAD"
    },
    NPR: {
      money_format: "Rs{{amount}}",
      money_with_currency_format: "Rs{{amount}} NPR"
    },
    ANG: {
      money_format: "&fnof;{{amount}}",
      money_with_currency_format: "{{amount}} NA&fnof;"
    },
    NZD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} NZD"
    },
    NIO: {
      money_format: "C${{amount}}",
      money_with_currency_format: "C${{amount}} NIO"
    },
    NGN: {
      money_format: "&#8358;{{amount}}",
      money_with_currency_format: "&#8358;{{amount}} NGN"
    },
    NOK: {
      money_format: "kr {{amount_with_comma_separator}}",
      money_with_currency_format: "kr {{amount_with_comma_separator}} NOK"
    },
    OMR: {
      money_format: "{{amount_with_comma_separator}} OMR",
      money_with_currency_format: "{{amount_with_comma_separator}} OMR"
    },
    PKR: {
      money_format: "Rs.{{amount}}",
      money_with_currency_format: "Rs.{{amount}} PKR"
    },
    PGK: {
      money_format: "K {{amount}}",
      money_with_currency_format: "K {{amount}} PGK"
    },
    PYG: {
      money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format: "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
    },
    PEN: {
      money_format: "S/. {{amount}}",
      money_with_currency_format: "S/. {{amount}} PEN"
    },
    PHP: {
      money_format: "&#8369;{{amount}}",
      money_with_currency_format: "&#8369;{{amount}} PHP"
    },
    PLN: {
      money_format: "{{amount_with_comma_separator}} zl",
      money_with_currency_format: "{{amount_with_comma_separator}} zl PLN"
    },
    QAR: {
      money_format: "QAR {{amount_with_comma_separator}}",
      money_with_currency_format: "QAR {{amount_with_comma_separator}}"
    },
    RON: {
      money_format: "{{amount_with_comma_separator}} lei",
      money_with_currency_format: "{{amount_with_comma_separator}} lei RON"
    },
    RUB: {
      money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
      money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
    },
    RWF: {
      money_format: "{{amount_no_decimals}} RF",
      money_with_currency_format: "{{amount_no_decimals}} RWF"
    },
    WST: {
      money_format: "WS$ {{amount}}",
      money_with_currency_format: "WS$ {{amount}} WST"
    },
    SAR: {
      money_format: "{{amount}} SR",
      money_with_currency_format: "{{amount}} SAR"
    },
    STD: {
      money_format: "Db {{amount}}",
      money_with_currency_format: "Db {{amount}} STD"
    },
    RSD: {
      money_format: "{{amount}} RSD",
      money_with_currency_format: "{{amount}} RSD"
    },
    SCR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} SCR"
    },
    SGD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} SGD"
    },
    SYP: {
      money_format: "S&pound;{{amount}}",
      money_with_currency_format: "S&pound;{{amount}} SYP"
    },
    ZAR: {
      money_format: "R {{amount}}",
      money_with_currency_format: "R {{amount}} ZAR"
    },
    KRW: {
      money_format: "&#8361;{{amount_no_decimals}}",
      money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW"
    },
    LKR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} LKR"
    },
    SEK: {
      money_format: "{{amount_no_decimals}} kr",
      money_with_currency_format: "{{amount_no_decimals}} kr SEK"
    },
    CHF: {
      money_format: "SFr. {{amount}}",
      money_with_currency_format: "SFr. {{amount}} CHF"
    },
    TWD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} TWD"
    },
    THB: {
      money_format: "{{amount}} &#xe3f;",
      money_with_currency_format: "{{amount}} &#xe3f; THB"
    },
    TZS: {
      money_format: "{{amount}} TZS",
      money_with_currency_format: "{{amount}} TZS"
    },
    TTD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} TTD"
    },
    TND: {
      money_format: "{{amount}}",
      money_with_currency_format: "{{amount}} DT"
    },
    TRY: {
      money_format: "{{amount}}TL",
      money_with_currency_format: "{{amount}}TL"
    },
    UGX: {
      money_format: "Ush {{amount_no_decimals}}",
      money_with_currency_format: "Ush {{amount_no_decimals}} UGX"
    },
    UAH: {
      money_format: "\u20B4{{amount}}",
      money_with_currency_format: "\u20B4{{amount}} UAH"
    },
    AED: {
      money_format: "Dhs. {{amount}}",
      money_with_currency_format: "Dhs. {{amount}} AED"
    },
    UYU: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} UYU"
    },
    VUV: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}}VT"
    },
    VEF: {
      money_format: "Bs. {{amount_with_comma_separator}}",
      money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF"
    },
    VND: {
      money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
      money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} VND"
    },
    XBT: {
      money_format: "{{amount_no_decimals}} BTC",
      money_with_currency_format: "{{amount_no_decimals}} BTC"
    },
    XOF: {
      money_format: "CFA{{amount}}",
      money_with_currency_format: "CFA{{amount}} XOF"
    },
    ZMW: {
      money_format: "K{{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format: "ZMW{{amount_no_decimals_with_comma_separator}}"
    }
  };
  multiCurrency.formatMoney = function(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;
    function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        `$1${thousands}`
      );
      const centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  };
  var currencies_default = multiCurrency;

  // app/scripts/bundler-builder.js
  var customElementsName = "custom-bundler-builder-container";
  !window.customElements.get(customElementsName) && window.customElements.define(
    customElementsName,
    class extends HTMLElement {
      constructor() {
        super();
        const productJsonElement = document.querySelector(
          '[id="product-json-metafield"]'
        );
        this.productJson = JSON.parse(productJsonElement.textContent);
        this.process = this.querySelector("process");
        this.listBtnContinute = this.querySelectorAll(".btn-continute");
        this.listBtnBack = this.querySelectorAll(".btn-back");
        this.step = 1;
        this.productSelectStep1 = this.getProductSelect1();
        if (this.productSelectStep1 == null)
          return;
        this.productSelectStep2 = [];
        this.productSelectStep3 = [];
        const templateTooltip = document.getElementById(
          "bundler-builder-tooltip"
        );
        this.templateContent = templateTooltip.content;
        this.headerheight = document.querySelector("store-header").offsetHeight;
      }
      connectedCallback() {
        this.init();
        this.addEvents();
        document.addEventListener("click", (event) => {
          if (event.target.closest(".jsRemoveProduct")) {
            let btn = event.target.closest(".jsRemoveProduct");
            let dataStep = +btn.dataset.step;
            this.activeContentByStep(dataStep);
            this.updateQuantityInputNextStep(dataStep);
          }
        });
        document.querySelectorAll(".jsToggleTooltip").forEach((tooltip) => {
          tooltip.addEventListener("mouseenter", () => {
            this.handleTooltip(tooltip, "mouseenter");
          });
          tooltip.addEventListener("mouseleave", () => {
            tooltip.classList.remove("show-tooltip");
          });
          tooltip.addEventListener("click", () => {
            clearTimeout(this.tooltipTimeout);
            this.tooltipTimeout = setTimeout(() => {
              this.handleTooltip(tooltip, "click");
            }, 300);
          });
        });
      }
      addEvents() {
        this.eventStep1();
        this.eventStep2();
        this.eventStep3();
        this.eventStep4();
        this.eventBtnContinute();
        this.eventBtnBack();
        this.eventSubmitForm();
      }
      eventSubmitForm() {
        this.querySelectorAll("form.popup-notification")?.forEach(
          (form) => form.addEventListener("submit", (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (!form.checkValidity()) {
              form.reportValidity();
              return;
            }
            let formData = new FormData(form);
            const email = formData.get("email");
            const variantId = formData.get("variant-id");
            const payload = {
              data: {
                type: "back-in-stock-subscription",
                attributes: {
                  profile: {
                    data: {
                      type: "profile",
                      attributes: {
                        email
                      }
                    }
                  },
                  channels: ["EMAIL"]
                },
                relationships: {
                  variant: {
                    data: {
                      type: "catalog-variant",
                      id: `$shopify:::$default:::${variantId}`
                    }
                  }
                }
              }
            };
            var requestOptions = {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                revision: "2024-06-15"
              },
              body: JSON.stringify(payload)
            };
            fetch(
              "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=UFZvec",
              requestOptions
            ).then((result) => {
              if (result.ok) {
                const popup = form.closest("popup-component");
                popup.querySelector(".res-noti .email-res").textContent = email;
                popup.querySelector(".res-noti").classList.toggle("hidden", false);
                form.classList.toggle("hidden-form", true);
                this.debounceTime(() => {
                  popup.close();
                }, 500);
              }
            }).catch((error) => console.error("error", error));
          })
        );
      }
      scrollToBundlerContainer() {
        const containerPosition = this.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: containerPosition - this.headerheight,
          behavior: "smooth"
        });
      }
      handleTooltip(tooltip, event) {
        let parentElm = tooltip.closest(".jsToggleTooltip");
        if (!parentElm.querySelector(".tooltip-container")) {
          let dataHandle = tooltip.dataset.tooltip;
          let targetElement = this.templateContent.querySelector(`.popup-tooltip[data-tooltip="${dataHandle}"]`).closest(".tooltip-container");
          let clonedElement = targetElement.cloneNode(true);
          parentElm.appendChild(clonedElement);
        }
        const container = parentElm.querySelector(".tooltip-container");
        const containerWidth = container.getBoundingClientRect().width;
        let btnRect = parentElm.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        let left = btnRect.left;
        let top = btnRect.top + 12;
        if (containerWidth + left > viewportWidth) {
          left = viewportWidth - containerWidth - 10;
        } else {
          left = left - containerWidth / 2;
        }
        parentElm.style.setProperty("--position-left", `${left}px`);
        parentElm.style.setProperty("--position-top", `${top}px`);
        parentElm.classList.toggle("show-tooltip", true);
        let popupTooltip = parentElm.querySelector(".popup-tooltip");
        if (event === "click") {
          popupTooltip.open();
        }
      }
      getProductSelect1() {
        const contentStep1 = this.querySelector(".content-step-1");
        if (!contentStep1)
          return null;
        const productActive1 = contentStep1.querySelector(
          ".product-card.active"
        );
        const productId = productActive1?.dataset?.productId;
        if (productId) {
          return [{ productId, quantity: 1 }];
        }
        return [];
      }
      init() {
        this.activeStep();
        this.updateGroupContent("init");
        this.heightContent();
        this.resize();
        this.initMedia();
        this.updateReviewProductCompre();
      }
      updateReviewProductCompre() {
        const listProduct = this.querySelectorAll(
          ".product-compare .product-reviews"
        );
        if (listProduct.length > 0) {
          listProduct.forEach(async (item) => {
            const { productId, reviewId } = item.dataset;
            const data = await this.fetchReviews(productId);
            if (data) {
              const rating_count = data[0]?.rollup.rating_count || 0;
              const average_rating = data[0]?.rollup.average_rating || 0;
              const ratingFloor = Math.floor(average_rating);
              const ratingDecimal = average_rating % 1;
              const ratingPercentage = Math.floor(ratingDecimal * 100);
              let starsHtml = "";
              for (let i = 1; i <= 5; i++) {
                if (i <= ratingFloor) {
                  starsHtml += `<span class="rating-star rate-star-white" style="--rating-decimal: 100%;"></span>`;
                } else if (i === ratingFloor + 1 && ratingPercentage > 0) {
                  starsHtml += `<span class="rating-star rate-star-white" style="--rating-decimal: ${ratingPercentage}%;"></span>`;
                } else {
                  starsHtml += `<span class="rating-star"></span>`;
                }
              }
              const bgFill = item.dataset.bgFill;
              const bgNotFill = item.dataset.bgNotFill;
              const reviewHtml = `
                <div class="reviews-star">
                  <p 
                    class="rating" 
                    role="svg" 
                    aria-label="rating: ${average_rating.toFixed(1)} / 5"
                    style="--rating: ${ratingFloor}; --rating-max: 5; --url-bg-fill: url('${bgFill}'); --url-bg-not-fill: url('${bgNotFill}');">
                    ${starsHtml}
                  </p>
                  <p class="rating-count caption">(${rating_count})</p>
                </div>
              `;
              item.innerHTML = reviewHtml;
            }
          });
        }
      }
      fetchReviews = async (productId) => {
        const locale = "en_US";
        const merchantId = "761182";
        const pageIds = productId;
        const apikey = "bde9002d-df39-4aa9-bd0d-f6e7ac685269";
        const endpoint = `https://readservices-b2c.powerreviews.com/m/${merchantId}/l/${locale}/product/${pageIds}/snippet`;
        try {
          const response = await fetch(endpoint, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `${apikey}`
            }
          });
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          const data = await response.json();
          return data?.results;
        } catch (error) {
          return null;
        }
      };
      resize() {
        window.addEventListener(
          "resize",
          this.debounceTime((e) => {
            this.heightContent();
            this.headerheight = document.querySelector("store-header").offsetHeight;
          }, 300)
        );
      }
      heightContent() {
        let item = this.querySelector(".content-step.active");
        let contentMedia = item.querySelector(".content-media");
        if (contentMedia) {
          let height = contentMedia.clientHeight;
          item.style.setProperty("--height", `${height}px`);
        }
      }
      activeStep() {
        const step = this.step;
        const processSteps = this.process.querySelectorAll(".process-step");
        const btnBack = this.querySelector(".header-wapper .btn-back");
        const spacings = this.process.querySelectorAll(".spacing");
        processSteps.forEach((item, index) => {
          const isCurrentStep = index + 1 === step;
          const isBeforeCurrentStep = index + 1 < step;
          item.classList.toggle("active", isCurrentStep || isBeforeCurrentStep);
          item.classList.toggle("success", isBeforeCurrentStep);
        });
        btnBack.classList.toggle("isStep1", step === 1);
        spacings.forEach((item, index) => {
          item.classList.toggle("active", index + 1 < step);
        });
      }
      updateTotalPrice(event) {
        const step = this.getStep(event);
        const groupAction = this.querySelector(
          `.content-step-${step} .group-action-event`
        );
        if (!groupAction)
          return;
        const { price, comparePrice } = this.formatPrice(step);
        const currentPriceElement = groupAction.querySelector(".current-price");
        const comparePriceElement = groupAction.querySelector(".price-compare");
        if (currentPriceElement && comparePriceElement) {
          currentPriceElement.innerHTML = price;
          comparePriceElement.innerHTML = comparePrice;
        }
      }
      getStep(event) {
        switch (event) {
          case "init":
            return this.step;
          case "next":
            return this.step + 1;
          case "back":
            return this.step - 1;
          default:
            return this.step;
        }
      }
      updateTotalPriceStep4() {
        const step = 3;
        const discount = parseFloat(this.productJson.discount_value || 0);
        const groupAction = this.querySelector(
          `.content-step-4 .group-action-event`
        );
        if (!groupAction)
          return;
        const { price, comparePrice } = this.formatPrice(step, discount);
        const currentPrice = groupAction.querySelector(".current-price");
        const comparePriceElement = groupAction.querySelector(".price-compare");
        if (currentPrice) {
          currentPrice.innerHTML = price;
        }
        if (comparePriceElement) {
          comparePriceElement.innerHTML = comparePrice;
        }
      }
      activeMediaStep(productHandle) {
        const step = this.step;
        const contentStep = this.querySelector(`.content-step-${step}`);
        if (!contentStep)
          return;
        const contentMediaStep = contentStep.querySelector(".content-media");
        if (!contentMediaStep)
          return;
        const elmMediaStep = contentMediaStep.querySelector(
          `template[id="media-gallery-metafield-${step}"]`
        );
        if (!elmMediaStep)
          return;
        const templateContent = elmMediaStep.content;
        const media = templateContent.querySelector(
          `.media-gallery[data-product-handle="${productHandle}"]`
        );
        if (!media)
          return;
        const clonedMedia = media.cloneNode(true);
        const existingMediaGallery = contentMediaStep.querySelector(".media-gallery");
        if (existingMediaGallery) {
          existingMediaGallery.remove();
        }
        contentMediaStep.appendChild(clonedMedia);
        window.initLazyImages();
      }
      initMedia() {
        this.querySelectorAll("media-gallery").forEach((item) => {
          item.init();
        });
        window.initLazyImages();
      }
      eventStep1() {
        let contentStep1 = this.querySelector(".content-step-1");
        let listProduct1 = contentStep1.querySelectorAll(".product-card");
        listProduct1.forEach(
          (productCard) => productCard.addEventListener("click", (event) => {
            const productCardActive = event.target.closest(".product-card");
            listProduct1.forEach((item) => {
              item.classList.toggle("active", false);
            });
            productCardActive.classList.toggle("active", true);
            const productHandle = productCardActive.dataset.productHandle;
            this.activeMediaStep(productHandle);
            const matchingProducts = [
              ...this.productJson.step1.products
            ].filter(
              (product) => productCardActive.dataset.productId == product.id
            );
            if (matchingProducts[0].available) {
              const newObject = this.createProductObject(
                matchingProducts[0].id,
                1
              );
              this.productSelectStep1 = [newObject];
            } else {
              this.productSelectStep1 = [];
            }
            this.updateGroupContent("init");
          })
        );
      }
      eventStep2() {
        const contentStep = this.querySelector(".content-step-2");
        const listProduct2 = contentStep.querySelectorAll(
          ".product-card input[type=radio]"
        );
        listProduct2.forEach(
          (inputCheckbox) => inputCheckbox.addEventListener("click", (event) => this.setActiveProductCard(event.target))
        );
        contentStep.addEventListener("event-input", (event) => {
          this.updateJsonStep(2);
          this.updateTotalPrice("init");
          this.updateGroupBtnAction(2);
        });
      }
      setActiveProductCard(input) {
        let productCardActive = input.closest(".product-card");
        const productHandle = productCardActive.dataset.productHandle;
        this.activeMediaStep(productHandle);
      }
      eventStep3() {
        const contentStep = this.querySelector(".content-step-3");
        contentStep.addEventListener("event-input", (event) => {
          this.updateJsonStep(3);
          this.updateTotalPrice("init");
          this.updateGroupBtnAction(3);
        });
      }
      eventStep4() {
        const contentStep = this.querySelector(".content-step-4");
        const btnAddtoCart = contentStep.querySelector(
          ".group-action-event button.btn-atc"
        );
        btnAddtoCart.addEventListener("click", (event) => {
          btnAddtoCart.classList.add("loading");
          const id = `uniqueId-${this.generateRandomId()}`;
          const steps = [1, 2, 3].reduce((acc, stepIndex) => {
            const key = `productSelectStep${stepIndex}`;
            return acc.concat(
              this[key].map((item) => ({
                id: item.productId,
                quantity: item.quantity,
                properties: {
                  _bundle_builder: id,
                  _bb: true
                }
              }))
            );
          }, []);
          const formData = { items: steps };
          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(formData)
          }).then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          }).then((data) => {
            btnAddtoCart.classList.remove("loading");
            window.location.href = `${window.location.origin}/cart`;
          }).catch((error) => {
            console.error("Error:", error);
            btnAddtoCart.classList.remove("loading");
          });
        });
      }
      eventBtnContinute() {
        this.listBtnContinute.forEach(
          (btn) => btn.addEventListener("click", (event) => {
            if (this.step == 3) {
              this.updateGroupContent("next");
              this.activeGroupContent("next");
              this.step = this.step + 1;
              this.activeStep();
            } else {
              let productSelectKey = `productSelectStep${this.step}`;
              if (this[productSelectKey].length > 0) {
                this.activeGroupContent("next");
                if (this.step == 2) {
                  this.activeProductRequiredStep3();
                }
                if (this.step == 1) {
                  this.updateQuantityInputNextStep(1);
                }
                this.updateGroupContent("next");
                this.step = this.step + 1;
                this.activeStep();
              }
            }
            this.initMedia();
            if (this.step == 2) {
              this.updateProductMediaFirst();
            }
            this.heightContent();
            this.scrollToBundlerContainer();
          })
        );
      }
      updateProductMediaFirst() {
        const productCartFirst = this.querySelector(`div.content-step-2 .group .product-card:not(.none)`);
        if (productCartFirst) {
          const input = productCartFirst.querySelector("input[type=radio]");
          input.checked = true;
          this.setActiveProductCard(input);
        }
      }
      eventBtnBack() {
        this.listBtnBack.forEach(
          (btn) => btn.addEventListener("click", (event) => {
            this.updateGroupContent("back");
            this.activeGroupContent("back");
            this.initMedia();
            this.step = this.step - 1;
            this.activeStep();
            this.heightContent();
            this.scrollToBundlerContainer();
            this.updateQuantityInputNextStep(this.step);
          })
        );
      }
      activeGroupContent(event) {
        if (event == "next") {
          let _step = this.step + 1;
          this.activeProductCardByStep(_step);
          this.querySelectorAll("div.content-step").forEach((item) => {
            let className = `content-step-${_step}`;
            item.classList.toggle(
              "active",
              !!item.classList.contains(className)
            );
          });
        }
        if (event == "back") {
          let _step = this.step - 1;
          this.activeProductCardByStep(_step);
          this.querySelectorAll("div.content-step").forEach((item) => {
            let className = `content-step-${_step}`;
            item.classList.toggle(
              "active",
              !!item.classList.contains(className)
            );
          });
        }
        if (event == "init") {
          let _step = this.step;
          this.activeProductCardByStep(_step);
          this.querySelectorAll("div.content-step").forEach((item) => {
            let className = `content-step-${_step}`;
            item.classList.toggle(
              "active",
              !!item.classList.contains(className)
            );
          });
          this.initMedia();
        }
      }
      updateGroupContent(event) {
        if (event == "next") {
          if (this.step == 1 || this.step == 2) {
            let _step = this.step + 1;
            this.updateGroupBtnAction(_step);
            this.updateGroupProductSelect(_step);
            this.updateTotalPrice("next");
          }
          if (this.step == 3) {
            this.updateContentStep4();
            this.updateTotalPriceStep4("next");
          }
        }
        if (event == "back") {
          let _step = this.step - 1;
          this.updateGroupBtnAction(_step);
          this.updateGroupProductSelect(_step);
          this.updateTotalPrice("back");
        }
        if (event == "init") {
          let _step = this.step;
          this.updateGroupBtnAction(_step);
          this.updateGroupProductSelect(_step);
          this.updateTotalPrice("init");
        }
      }
      activeProductRequiredStep3() {
        const productRequired = this.querySelectorAll(
          `div.content-step-3 .list-product .product-card.tag-required:not(.none)`
        );
        if (productRequired.length > 0) {
          productRequired.forEach((product) => {
            const inputElement = product.querySelector("input[type=number]");
            if (inputElement) {
              inputElement.value = 1;
            }
          });
        }
        this.updateJsonStep(3);
      }
      activeContentByStep(step) {
        this.step = step;
        this.updateGroupContent("init");
        this.activeGroupContent("init");
        this.activeStep();
        this.heightContent();
      }
      activeProductCardByStep(step) {
        const _step = parseInt(step - 1);
        if (step != 2 && step != 3)
          return;
        const keyProductSelectStep = `productSelectStep${_step}`;
        const array1 = this[keyProductSelectStep];
        const array2 = this.productJson[`step${_step}`].products;
        if (step == 3) {
          const result = array2.reduce((acc, item) => {
            const matchedProduct = array1.find((p) => p.productId === item.id);
            if (matchedProduct) {
              let combinedIds = [...item.compatible].map((id) => id.toString());
              acc.push(...combinedIds);
            }
            return acc;
          }, []);
          this.querySelectorAll(
            `div.content-step-${step} .list-product .product-card`
          ).forEach((item) => {
            const dataId = item.dataset.productId.toString();
            const isInResult = result.map((id) => id.toString()).includes(dataId);
            item.classList.toggle("none", !isInResult);
          });
        }
        if (step == 2) {
          const listGroup = ["wi-fi-displays", "non-wi-fi-displays"];
          let checkElmFirst = false;
          listGroup.forEach((groupName) => {
            let activeGroup = false;
            const result = array2.reduce((acc, item) => {
              const matchedProduct = array1.find(
                (p) => p.productId === item.id
              );
              if (matchedProduct) {
                let combinedIds = [...item.compare_list[groupName]].map(
                  (id) => id.toString()
                );
                acc.push(...combinedIds);
              }
              return acc;
            }, []);
            const group2 = this.querySelectorAll(`div.content-step-${step} .group.${groupName}`);
            if (!group2)
              return;
            this.querySelectorAll(
              `div.content-step-${step} .group.${groupName} .product-card`
            )?.forEach((item) => {
              const dataId = item.dataset.productId.toString();
              const isInResult = result.map((id) => id.toString()).includes(dataId);
              item.classList.toggle("none", !isInResult);
              if (isInResult) {
                activeGroup = true;
              }
            });
            if (!this.querySelector(`div.content-step-${step} .group.${groupName}`))
              return;
            this.querySelector(
              `div.content-step-${step} .group.${groupName}`
            ).classList.toggle("group-hidden", !activeGroup);
            this.querySelectorAll(
              `div.content-step-${step} .compare-products .product-compare.${groupName}`
            )?.forEach((productCard, index) => {
              const dataId = productCard.dataset.productId.toString();
              const isInResult = result.map((id) => id.toString()).includes(dataId);
              productCard.classList.toggle("none", !isInResult);
              if (checkElmFirst == false && isInResult) {
                checkElmFirst = true;
                productCard.classList.toggle("firstElm", true);
              } else {
                productCard.classList.toggle("firstElm", false);
              }
            });
          });
          const group = this.querySelectorAll(
            `div.content-step-${step} .group`
          );
          const groupHidden = this.querySelectorAll(
            `div.content-step-${step} .group.group-hidden`
          );
          this.querySelector(`div.content-step-${step}`).classList.toggle(
            "not-compatible",
            group.length == groupHidden.length
          );
        }
      }
      updateContentStep4() {
        const contentStepKey = `content-step-4`;
        const { listNode: products, total } = this.createProductCard(4);
        if (!products.length)
          return;
        const disclosureContent = this.querySelector(
          `.${contentStepKey} .list-product`
        );
        disclosureContent.innerHTML = "";
        products.forEach((productCard) => {
          disclosureContent.append(productCard);
        });
      }
      updateGroupBtnAction(step) {
        let checkRequired = false;
        if (step == 3) {
          if (this.checkProductRequired()) {
            checkRequired = true;
          }
        } else {
          checkRequired = true;
        }
        let key = `productSelectStep${step}`;
        if (this[key]?.length > 0 && step != 3 || step == 3 && checkRequired == true) {
          this.querySelector(
            `.content-step-${step} .btn-continute`
          ).removeAttribute("disabled");
        } else {
          this.querySelector(
            `.content-step-${step} .btn-continute`
          ).setAttribute("disabled", true);
        }
      }
      checkProductRequired() {
        const productRequired = this.querySelectorAll(
          `div.content-step-3 .list-product .product-card.tag-required:not(.none)`
        );
        if (productRequired.length < 1)
          return true;
        return Array.from(productRequired).every((product) => {
          const inputElement = product.querySelector("input[type=number]");
          const inputValue = parseInt(inputElement.value);
          return inputValue >= 1;
        });
      }
      createProductCard(step) {
        const template = this.querySelector(
          `.content-step-2 details-disclosure template`
        );
        let listNode = [];
        let total = 0;
        for (let index = 1; index < step; index++) {
          const keyProductSelectStep = `productSelectStep${index}`;
          const keyStep = `step${index}`;
          this[keyProductSelectStep]?.forEach((objectProduct) => {
            const productCard = template.content.querySelector(".product-card").cloneNode(true);
            const product = this.productJson[keyStep].products.find(
              (product2) => objectProduct.productId == product2.id
            );
            if (product) {
              total += parseInt(objectProduct.quantity);
              let img = document.createElement("img");
              img.src = product.image;
              img.alt = `Product Image ${product.title}`;
              productCard.querySelector(".jsRemoveProduct").setAttribute("data-step", index);
              const productTitle = product.title;
              if (step < 4) {
                productCard.querySelector(".title").innerHTML = productTitle.length > 24 ? productTitle.substring(0, 24) + "..." : productTitle;
              } else {
                productCard.querySelector(".title").innerHTML = productTitle;
              }
              productCard.querySelector(".quantity").innerHTML = objectProduct.quantity;
              productCard.querySelector(".price").innerHTML = product.price;
              productCard.querySelector(".compare-price").innerHTML = product.compare_at_price;
              productCard.querySelector(".image").innerHTML = "";
              productCard.querySelector(".image").appendChild(img);
              listNode.push(productCard);
            }
          });
        }
        return { listNode, total };
      }
      updateGroupProductSelect(step) {
        const contentStepKey = `content-step-${step}`;
        const { listNode: products, total } = this.createProductCard(step);
        if (!products.length)
          return;
        const disclosureContent = this.querySelectorAll(
          `.${contentStepKey} .station-group .disclosure__content`
        );
        disclosureContent.forEach((item) => {
          item.innerHTML = "";
          products.forEach((productCard) => {
            const clonedProductCard = productCard.cloneNode(true);
            item.append(clonedProductCard);
          });
        });
        const countElm = this.querySelectorAll(
          `.${contentStepKey} .jsUpdateCountStation`
        );
        countElm.forEach((countElm2) => {
          countElm2.textContent = total;
        });
      }
      updateJsonStep(step) {
        const jsonStepKey = `productSelectStep${step}`;
        const contentStep = this.querySelector(`.content-step-${step}`);
        const listProduct = contentStep.querySelectorAll(
          ".product-card:not(.none) input[type=radio]"
        );
        let arrayJson = [];
        listProduct.forEach((item) => {
          const productCard = item.closest(".product-card");
          const quantity = parseInt(productCard.querySelector("input[type=number]")?.value) || 0;
          if (!quantity)
            return;
          const stepKey = `step${step}`;
          if (quantity > 0) {
            const matchingProducts = [
              ...this.productJson[stepKey].products
            ].filter((product) => productCard.dataset.productId == product.id);
            if (matchingProducts[0].available) {
              const newObject = this.createProductObject(
                matchingProducts[0].id,
                quantity
              );
              const existingIndex = arrayJson.findIndex(
                (product) => product.productId === newObject.productId
              );
              if (existingIndex !== -1) {
                arrayJson[existingIndex].quantity += quantity;
              } else {
                arrayJson.push(newObject);
              }
            }
          }
        });
        this[jsonStepKey] = arrayJson;
      }
      updateQuantityInputNextStep(step) {
        for (let index = 3; index > step; index--) {
          const keyProductSelectStep = `productSelectStep${index}`;
          this[keyProductSelectStep] = [];
          const contentStep = this.querySelector(`.content-step-${index}`);
          const listProduct = contentStep.querySelectorAll(
            ".product-card input[type=radio]"
          );
          listProduct.forEach((item) => {
            const productCard = item.closest(".product-card");
            if (productCard.querySelector("input[type=number]")) {
              productCard.querySelector("input[type=number]").value = 0;
            }
          });
        }
      }
      createProductObject(productId, quantity) {
        return {
          productId,
          quantity
        };
      }
      formatPrice(step, discount = 0) {
        let price = 0;
        let comparePrice = 0;
        const steps = [
          {
            products: this.productJson.step1.products,
            selected: this.productSelectStep1
          },
          {
            products: this.productJson.step2.products,
            selected: this.productSelectStep2
          },
          {
            products: this.productJson.step3.products,
            selected: this.productSelectStep3
          }
        ];
        for (let i = 0; i < step; i++) {
          steps[i].selected.forEach((selectedItem) => {
            let matchingProducts = steps[i].products.filter(
              (product) => selectedItem.productId == product.id
            );
            if (matchingProducts[0]) {
              price += parseFloat(
                matchingProducts[0]._price * selectedItem.quantity
              );
              let tempComparePrice = 0;
              if (matchingProducts[0]._compare_at_price > 0) {
                tempComparePrice = matchingProducts[0]._compare_at_price * selectedItem.quantity;
              } else {
                tempComparePrice = matchingProducts[0]._price * selectedItem.quantity;
              }
              comparePrice += parseFloat(tempComparePrice);
            }
          });
        }
        if (discount > 0 && price > 0) {
          comparePrice = price;
          price = parseFloat(price - price * discount);
          price = this.formatMoney(price, "money_with_currency_format");
          comparePrice = this.formatMoney(comparePrice, "money_format");
          return {
            price,
            comparePrice
          };
        }
        if (comparePrice == 0 || comparePrice == price) {
          comparePrice = "";
        } else {
          comparePrice = this.formatMoney(comparePrice, "money_format");
        }
        if (price == 0) {
          price = "";
        } else {
          price = this.formatMoney(price, "money_with_currency_format");
        }
        return {
          price,
          comparePrice
        };
      }
      formatMoney(value, format = "money_with_currency_format") {
        let iso = this.dataset.isocode;
        let f = currencies_default.moneyFormats[iso][format];
        return currencies_default.formatMoney(value, f);
      }
      debounceTime(fn, wait = 300) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }
      generateRandomId() {
        const randomPart = Math.random().toString(36).substr(2, 9);
        const timestampPart = Date.now().toString(36);
        return `${timestampPart}-${randomPart}`;
      }
    }
  );
  var QuantityInputBundler = class extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector(".qty-input__input");
      this.currentQty = this.input.value;
      this.changeEvent = new Event("change", { bubbles: true });
      this.addEventListener("click", this.handleClick.bind(this));
      this.input.addEventListener("focus", QuantityInput.handleFocus);
      this.input.addEventListener("keydown", this.handleKeydown.bind(this));
      this.input.addEventListener("input", () => {
        this.dispatchEvent(new CustomEvent("event-input", { bubbles: true }));
      });
    }
    /**
     * Handles 'click' events on the quantity input element.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      if (!evt.target.matches(".qty-input__btn"))
        return;
      evt.preventDefault();
      this.currentQty = this.input.value;
      if (evt.target.name === "plus") {
        this.input.stepUp();
      } else {
        this.input.stepDown();
      }
      if (this.input.value !== this.currentQty) {
        this.input.dispatchEvent(this.changeEvent);
        this.input.dispatchEvent(
          new CustomEvent("event-input", { bubbles: true })
        );
        this.currentQty = this.input.value;
      }
    }
    /**
     * Handles 'focus' events on the quantity input element.
     * @param {object} evt - Event object.
     */
    static handleFocus(evt) {
      if (window.matchMedia("(pointer: fine)").matches) {
        evt.target.select();
      }
    }
    /**
     * Handles 'keydown' events on the input field.
     * @param {object} evt - Event object.
     */
    handleKeydown(evt) {
      if (evt.key !== "Enter")
        return;
      evt.preventDefault();
      if (this.input.value !== this.currentQty) {
        this.input.blur();
        this.input.focus();
        this.currentQty = this.input.value;
      }
    }
  };
  customElements.define("quantity-input-bundler", QuantityInputBundler);
  document.querySelector(".btn-bundler-builder")?.addEventListener("click", () => {
    document.body.classList.toggle("show-bundler-builder", true);
  });
})();
